<template>
	<core-modal
		:name="campaign.id + '-delete-modal'"
		class="omapi-modal delete-modal"
		:click-to-close="!isDeletingCampaign"
		:is-confirmation="true"
		:child-refs="$refs"
	>
		<modals-content>
			<form @submit.prevent="deleteCampaignHandler">
				<p>
					Are you sure you want to <strong>permanently</strong> delete the {{ campaign.name }} ({{
						campaign.id
					}}) campaign? This will <strong>also delete any split tests</strong> connected to the deleted
					campaign.
				</p>

				<section class="buttons">
					<core-loading-button
						ref="toFocus"
						class="delete-campaign"
						color="blue"
						size="large"
						button-type="submit"
						:loading="isDeletingCampaign"
					>
						Yes, I'm Sure
					</core-loading-button>
					<button
						class="omapi-button omapi-button__white omapi-button__large"
						:disabled="isDeletingCampaign"
						@click.prevent="$modal.hide(campaign.id + '-delete-modal')"
					>
						Cancel
					</button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('campaigns');

export default {
	props: {
		campaign: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			isDeletingCampaign: false,
		};
	},
	methods: {
		...mapActions(['deleteCampaign']),
		async deleteCampaignHandler() {
			const message = `The ${this.campaign.name} campaign was deleted successfully.`;
			this.isDeletingCampaign = true;
			await this.deleteCampaign(this.campaign);

			this.isDeletingCampaign = false;
			this.$store.commit('campaigns/addAlert', {
				message,
				type: 'success',
			});
			this.$modal.hide(this.campaign.id + '-delete-modal');
		},
	},
};
</script>
